module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error"
    },
    model: {
      value: (_vm.showError),
      callback: function($$v) {
        _vm.showError = $$v
      },
      expression: "showError"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.sub))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (props.item.email_verified),
            callback: function($$v) {
              _vm.$set(props.item, "email_verified", $$v)
            },
            expression: "props.item.email_verified"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (props.item.enabled),
            callback: function($$v) {
              _vm.$set(props.item, "enabled", $$v)
            },
            expression: "props.item.enabled"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.status))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-67cf9d17"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Users.vue
// module id = 940
// module chunks = 1